
























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class Password extends Vue {
  @Prop({default: 'Password'})
  protected placeholder?: string;
  protected clearPassword: boolean = false;
  protected isValidEmail: boolean = false;
  protected value?: number | string;

  protected hidePassword() {
    this.clearPassword = true;
  }

  protected showPassword() {
    this.clearPassword = false;
  }

  //   @Prop()

  //   inputVal?: number | string;
  protected data() {
    return {inputVal: this.value};
  }

  @Watch('inputVal')
  private onModelChanged(value: number | string, oldValue: number | string) {
    this.$emit('input', value);
  }
}
